require("./other-offerings.scss");
